import { useCurrentProductStore } from "../hooks/use-current-product-store.js";
import { useMemo } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
import { useMenubar } from "@tecsinapse/cortex-react";
import { Link } from "react-router-dom";
//#region src/modules/core/components/menu-link.tsx
var MenuLink = ({ to, children, className, linkPortal }) => {
	const [, setShow] = useMenubar();
	const currentProduct = useCurrentProductStore((state) => state.currentProduct);
	return /* @__PURE__ */ jsx(Fragment, { children: useMemo(() => currentProduct === "PORTAL", [currentProduct]) ? /* @__PURE__ */ jsx(Link, {
		to,
		className,
		onClick: () => {
			setShow(false);
		},
		children
	}) : /* @__PURE__ */ jsx("a", {
		href: `${linkPortal}/${to}`,
		target: "_self",
		children
	}) });
};
//#endregion
export { MenuLink };
